import { render, staticRenderFns } from "./CadastroGrupo.vue?vue&type=template&id=463ea542"
import script from "./CadastroGrupo.vue?vue&type=script&lang=js"
export * from "./CadastroGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports